// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import DocPassSvg from '@rsuite/icon-font/lib/file/DocPass';
var DocPass = createSvgIcon({
  as: DocPassSvg,
  ariaLabel: 'doc pass',
  category: 'file',
  displayName: 'DocPass'
});
export default DocPass;